import { Combobox } from "@headlessui/react";

import styled from "styled-components/macro";

import { motion } from "framer-motion";

export const Icon = styled.i`
  font-size: ${(props) => props.size || "inherit"};
  rotate: ${(props) => (props.rotated ? "-180deg" : "0deg")};
  transition: rotate 0.2s ease-in-out;
  color: ${(props) => props.color || "inherit"};

  &.hide-icon {
    opacity: 0;
  }
`;

export const HoverIcon = styled(Icon)`
  &:hover {
    cursor: pointer;
  }
`;

export const InputContainer = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 5px;
  background: ${(props) =>
    props.$hideInput ? "transparent" : "hsl(0 0% 0% / 0.2)"};
  padding: ${(props) => (props.$hideInput ? "0px" : "1px 2px")};
  margin-bottom: ${(props) => (props.$hideInput ? "1px" : "5px")};

  i {
    font-size: ${(p) => p.size ?? "14px"};
  }
`;

export const Input = styled.input`
  height: ${({ hideInput }) => (hideInput ? "1px" : "auto")};
  border: 0px solid transparent;
  padding: 0;
  margin: 0;
  transition: all 0.2s ease-in-out;
  transform-origin: top;
  background: transparent;
  color: white;

  &:focus {
    outline: none;
  }
`;

export const HeadlessButton = styled(Combobox.Button)`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  padding: 0;
  margin: 0;
  border: none;
  opacity: 0;
  cursor: pointer;
  &:disabled {
    cursor: default;
  }
`;
export const Button = styled.button`
  box-sizing: border-box;
  max-width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 150ms;
  position: relative;

  .truncate {
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover {
    background-color: #efefef;
  }

  &:focus {
    outline: ${(props) =>
      props.$focusColor
        ? `2px solid ${props.focusColor}b5`
        : `2px solid #248cc0b5`};
  }
`;

export const Options = styled(Combobox.Options)`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const Option = styled.li``;

export const OptionInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  color: black;
  padding: 6px 10px;
  color: white;
  /* opacity: ${({ selected }) => (selected ? 1 : 0.9)}; */
  background: ${({ active }) => (active ? "rgba(255, 255, 255, 0.15)" : null)};
  display: flex;
  border-radius: 10px;
  cursor: pointer;
  transition: background 150ms;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
  }
`;
